import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext.tsx';

const FONT = "'system-ui', '-apple-system', 'sans-serif'";

const NAV_ITEMS = [
  { label: 'Dashboard',     path: '/admin' },
  { label: 'Tenants',       path: '/admin/tenants' },
  { label: 'Planes',        path: '/admin/planes' },
  { label: 'Usuarios',      path: '/admin/usuarios' },
  { label: 'Configuracion', path: '/admin/configuracion' },
  { label: 'Logs',          path: '/admin/logs' },
];

// Colores fijos — no dependen de tokens CSS del proyecto
const S = {
  sidebarBg:     '#0f172a',
  sidebarBorder: '#1e293b',
  sidebarActive: '#1e3a5f',
  textMuted:     '#64748b',
  textActive:    '#f1f5f9',
  accent:        '#38bdf8',
  mainBg:        '#0d1117',
};

export function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      minHeight: '100vh',
      fontFamily: FONT,
      alignItems: 'stretch',
    }}>

      {/* ── Sidebar ── */}
      <aside style={{
        width: 220,
        minWidth: 220,
        maxWidth: 220,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        background: S.sidebarBg,
        borderRight: `1px solid ${S.sidebarBorder}`,
        padding: '24px 12px',
        boxSizing: 'border-box',
        position: 'sticky',
        top: 0,
        height: '100vh',
        overflowY: 'auto',
      }}>

        {/* Logo */}
        <div style={{ padding: '0 12px', marginBottom: 32 }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', color: S.accent, textTransform: 'uppercase' }}>
            Impulsa ERP
          </div>
          <div style={{ fontSize: 11, color: S.textMuted, marginTop: 3 }}>
            Panel Maestro
          </div>
        </div>

        {/* Nav */}
        <nav style={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1 }}>
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/admin'}
              style={({ isActive }) => ({
                display: 'block',
                padding: '8px 12px',
                borderRadius: 6,
                fontSize: 14,
                fontWeight: isActive ? 500 : 400,
                color: isActive ? S.textActive : S.textMuted,
                background: isActive ? S.sidebarActive : 'transparent',
                textDecoration: 'none',
                fontFamily: FONT,
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div style={{ paddingTop: 16, borderTop: `1px solid ${S.sidebarBorder}` }}>
          <div style={{
            fontSize: 12,
            color: S.textMuted,
            marginBottom: 8,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            padding: '0 12px',
            fontFamily: FONT,
          }}>
            {user?.email ?? 'superadmin'}
          </div>
          <button
            onClick={logout}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '8px 12px',
              borderRadius: 6,
              fontSize: 14,
              color: S.textMuted,
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontFamily: FONT,
            }}
          >
            Cerrar sesion
          </button>
        </div>
      </aside>

      {/* ── Main ── */}
      <main style={{
        flex: 1,
        overflow: 'auto',
        padding: 32,
        background: S.mainBg,
        fontFamily: FONT,
      }}>
        <Outlet />
      </main>
    </div>
  );
}
